export default __webpack_public_path__ + "5974feb9816bbc93d7c555fd1895f61b.ttf";